module.exports = __webpack_public_path__ + "img/empty.d204d3f9.png";